<template>
  <div>
    <div class="row mb-5 mb-md-3">
      <div class="col-auto">
        <h2>{{ $t(formTitles[currentStep]) }}</h2>
      </div>
      <div class="col-auto">
        <div class="wizard">
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" v-bind:class="[currentStep == 1 ? 'active' : 'disabled']">
              <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
                <span class="round-tab" id="step1">1 </span>
              </a>
            </li>

            <li role="presentation" v-bind:class="[currentStep == 2 ? 'active' : 'disabled']">
              <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
                <span class="round-tab" id="step2">2 </span>
              </a>
            </li>
            <li role="presentation" v-bind:class="[currentStep == 3 ? 'active' : 'disabled']">
              <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
                <span class="round-tab" id="step3">3 </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div id="step1" v-show="currentStep == 1">
          <div>
            <div class="container-fluid d-flex justify-content-center form-base">
              <b-form ref="frmBasicData" @submit.stop.prevent="proceedBtnHandler">
                <div class="col-12 form1">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <my-input id="company-name" name="company-name" mandatory="true" :label="$t(LangConstants.company_name_input_label)" :placeholder="LangConstants.company_name_placeholder_label" inlinerows="false" classes="bg-gray" ref="companyName"></my-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-4" style="font-size: 16px; font-style: normal; font-weight: 600; line-height: 22px; letter-spacing: 0em; text-align: left;">
                        <b-form-group :label="$t(LangConstants.course_type)" v-slot="{ ariaDescribedby }">
                          <b-form-radio-group id="radio-group-2" v-model="selectedCourseType" :aria-describedby="ariaDescribedby" name="radio-sub-component">
                            <b-form-radio value="elearning" name="elearning" @change="changeCourseSelection(1)">{{$t(LangConstants.elearning)}}</b-form-radio>
                            <b-form-radio value="ilt" name="ilt" @change="changeCourseSelection(2)">{{$t(LangConstants.instructorled)}}</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-4">
                        <multi-select v-if="selectedCourseType == 'elearning'" id="course" name="course" :label="$t(LangConstants.courses_to_enrol_after_signup_input_label)" :mandatory="true" :placeholder="$t(LangConstants.select_courses_placeholder)" :tagplaceholder="$t(LangConstants.select_courses_tag_placeholder)" valuefield="courseid" :data="elearnCourses" textfield="text" inlinerows="false" classes="bg-gray" ref="courses"></multi-select>
                        <selector v-if="selectedCourseType == 'ilt'" id="course" name="course" :label="$t(LangConstants.courses_to_enrol_after_signup_input_label)" placeholder="" :data="iltCourses" valuefield="courseid" textfield="name" inlinerows="false" classes="bg-gray" ref="courses"></selector>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-4">
                        <selector id="account-manager" name="account-manager" :label="$t(LangConstants.account_manager_input_label)" placeholder="" :data="instructors" valuefield="userid" textfield="email" inlinerows="false" classes="bg-gray" ref="accountManager"></selector>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-4">
                        <selector id="team-lead" name="team-lead" :label="$t(LangConstants.customer_team_lead_ac_input_label)" placeholder="" :data="teamLeads" valuefield="userid" textfield="email" inlinerows="false" classes="bg-gray" ref="customerTeamLead"></selector>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-4">
                        <multi-select id="domain" name="domain" :label="$t(LangConstants.registration_domain_limit_input_label)" placeholder="@sparkcore.com" :tagplaceholder="$t(LangConstants.registration_domain_limit_tag_placeholder)" valuefield="id" :data="[]" textfield="text" inlinerows="false" classes="bg-gray" ref="domainLimit" :taggable="true"></multi-select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-4">
                        <my-input id="my-name" name="my-name" mandatory="true" :label="$t(LangConstants.max_allowed_registrations_input_label)" placeholder="" inlinerows="false" type="number" classes="bg-gray" ref="allowedRegsMax"></my-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <my-button fa="check" :label="$t(LangConstants.proceed_to_create_form_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
        <div id="step2" v-show="currentStep == 2">
          <div>
            <div class="container-fluid d-flex justify-content-center form-base">
              <b-form ref="frmCustomFields" @submit.stop.prevent="proceedBtnHandler">
                <div class="col-12 form2">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <my-input id="custom-title" name="title" mandatory="true" :label="$t(LangConstants.custom_title_input_label)" :placeholder="$t(LangConstants.custom_title_input_placeholder)" inlinerows="false" classes="bg-gray" ref="customTitle"></my-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <my-text-area id="description" name="description" mandatory="true" :label="$t(LangConstants.custom_description_input_label)" :placeholder="$t(LangConstants.custom_description_input_placeholder)" inlinerows="false" classes="bg-gray" ref="customDescription"></my-text-area>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <file-input id="fileformcreate" inlinerows="false" :label="$t(LangConstants.logo_input_label)" :placeholder="$t(LangConstants.logo_input_placeholder)" :dropplaceholder="$t(LangConstants.logo_input_drop_placeholder)" ref="logo"></file-input>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <template v-for="mfieldset in mandatoryFields">
                      <div v-for="mfield in mfieldset.fields" v-bind:key="mfield" class="col-md-6">
                        <div class="mb-4">
                          <my-input :id="mfield.value" name="my-name" :label="$t(mfield.label)" :placeholder="$t(mfield.placeholder)" inlinerows="false" classes="bg-gray" :type="mfield.type" disabled="true"></my-input>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-4">
                        <select-input-group id="input-sel" name="input-sel" :label="$t(LangConstants.add_other_fields_input_group_label)" placeholder="" :data="nonMandatoryFields" :textfield="textfield" inlinerows="false" classes="bg-gray" btn_fa="plus-circle" :btn_label="$t(LangConstants.add_fields_button_label)" btn_variant="box-general-grey" btn_classes="mr-1" btn_width="100%" @click="addNonMandatoryField"></select-input-group>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div class="row">
                    <div v-for="nmmfields in nonMandatoryFields" v-bind:key="nmmfields" class="col-md-12" :data-fieldset="nmmfields.value">
                      <div class="row" v-if="SelectedNonMandatory.includes(nmmfields.value)">
                        <div v-if="nmmfields.label" class="col-md-12 mt-2 mb-2">
                          <div class="row">
                            <div class="col-md-6">
                              <h4>{{ $t(nmmfields.label) }}</h4>
                              <span v-if="nmmfields.value == 9">These values will replace the values added in organization affliciation field</span>
                            </div>

                            <div v-if="nmmfields.fields.length > 1" class="col-md-6 d-flex align-items-end">
                              <my-button fa="trash" :label="$t(LangConstants.delete_fields_button_label)" variant="box-general-grey" classes="mb-3" height="47px" :width="btn_width" @onClick="deleteNonMandatoryField(nmmfields.value)"></my-button>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="row">
                            <div :id="nmmfields.value" v-for="nmmfield in nmmfields.fields" v-bind:key="nmmfield" class="col-md-6">
                              <my-text-area v-if="nmmfield.type == 'textarea'" :id="nmmfield.value" name="my-name" :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.placeholder)" inlinerows="false" classes="bg-gray" :type="nmmfield.type" ref="customCompanyList"></my-text-area>

                              <my-checkbox v-if="nmmfield.type == 'checkbox'" id="orderCertificate" name="orderCertificate" inlinerows="false" :defaultText="$t(nmmfield.placeholder)" secondaryText="" checkedValue="1" uncheckedValue="0" :label="$t(nmmfield.label)"> </my-checkbox>
                            
                              <my-input v-if="nmmfield.type != 'checkbox' && nmmfield.type != 'textarea'" :id="nmmfield.value" name="my-name" :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.placeholder)" inlinerows="false" classes="bg-gray" :type="nmmfield.type" disabled="true"></my-input>
                            </div>

                            <div v-if="nmmfields.fields.length == 1" class="col-md-6 d-flex align-items-end">
                              <my-button fa="trash" :label="$t(LangConstants.delete_field_button_label)" variant="box-general-grey" classes="mb-3" height="47px" :width="btn_width" @onClick="deleteNonMandatoryField(nmmfields.value)"></my-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4 row">
                    <div class="col">
                      <toggle-simple :label="$t(LangConstants.captcha_input_label)" :labelEnable="$t(LangConstants.yes_text)" :labelDisable="$t(LangConstants.no_text)" ref="captcha" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <my-button fa="check" :label="$t(LangConstants.proceed_to_generate_link_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
        <div id="step3" v-show="currentStep == 3">
          <div class="container-fluid d-flex justify-content-center form-base">
            <div class="col-12 form3">
              <div class="row">
                <div class="col-md-12">
                  <label for="">{{ $t(LangConstants.signup_form_share_helper_text) }}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-4">
                    <text-input-group id="my-name" name="my-name" mandatory="true" :label="$t(LangConstants.generated_link_input_group_label)" :placeholder="$t(LangConstants.generated_link_placeholder)" inlinerows="false" classes="bg-gray" btn_fa="link" :btn_label="$t(LangConstants.copy_url_address_button_label)" btn_variant="solid-primary" btn_classes="" btn_width="100%" btn_readOnly="true" ref="formUrl" @onClick="copyFormUrl()"></text-input-group>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-4"></div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <my-button fa="reply" :label="$t(LangConstants.back_to_overview_button_label)" variant="box-general-grey" classes="mb-2" height="48px" width="100%" type="submit" @onClick="proceedBtnHandler"></my-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Selector from "../atoms/Selector.vue";
import MyButton from "../atoms/Button.vue";
import MyInput from "../atoms/Input.vue";
import MyCheckbox from "../atoms/Checkbox.vue";
import ToggleSimple from "../atoms/ToggleSimple.vue";
//import MyRadio from "../atoms/Radio.vue";

import "../../assets/scss/stepper.scss";

import MyTextArea from "../atoms/TextArea.vue";
import TextInputGroup from "./TextInputGroup.vue";
import SelectInputGroup from "./SelectInputGroup.vue";
import FileInput from "../atoms/File.vue";
import MultiSelect from "../atoms/MultiSelector.vue";

import common from "../../functions/index";
import Constants from "../../constants/index";

export default {
  name: "sign-up-forms-wizard",

  computed: {
    courses() {
      return this.$store.state.courses;
    },
    elearnCourses() {
      let elearncourses = [];
      this.$store.state.courses.forEach(element => {
        if (element.type == "elearning") {
          elearncourses.push(element);
        }
      });
      return elearncourses;
    },
    iltCourses() {
      let iltcourses = [];
      this.$store.state.courses.forEach(element => {
        if (element.type == "instructor_led_training") {
          iltcourses.push(element);
        }
      });
      return iltcourses;
    },
    formTitles() {
      return this.$store.state.formTitles;
    },
    mandatoryFields() {
      return this.$store.state.mandatoryFields;
    },
    nonMandatoryFields() {
      return this.$store.state.nonMandatoryFields;
    },
    managers() {
      return this.$store.state.managers;
    },
    teamLeads() {
      return this.$store.state.teamLeads;
    },
    instructors() {
      return this.$store.state.instructors;
    },
    isCustomCompanyNameField(field) {
      return field.value == 9;
    },
    LangConstants() {
      return Constants;
    },
  },

  data: function() {
    return {
      currentStep: 1,
      userData: {},
      SelectedNonMandatory: [],
      selectedCourseType: 'elearning',
      courselist: []
    };
  },

  methods: {
    async proceedBtnHandler() {
      await this.setFormsData();

      switch (this.currentStep) {
        case 2: {
          this.$store.dispatch("addSignUpForm", JSON.stringify(this.userData)).then((result) => {
            if (result.success == true) {
              this.$fire({
                title: this.$t(result.message),
                // text: "text",
                type: "success",
                timer: 3000,
              }).then(() => {
                this.currentStep++;
                this.$refs.formUrl.selectedValue = this.$store.getters.spInstanceVueURL + result.data["url"];
              });
            } else {
              this.$fire({
                title: this.$t(result.message),
                // text: "text",
                type: "error",
                html: "",
              });
            }
          });
          
          break;
        }
        case 3: {
          this.currentStep = 1;
          this.$parent.$parent.currentTab = 0;
          this.$refs.frmBasicData.reset();
          this.$refs.frmCustomFields.reset();
          this.SelectedNonMandatory = [];
          this.$refs.logo.clearAll();
          this.$refs.courses.clearAll();
          this.$refs.domainLimit.clearAll();
          this.$refs.formUrl.selectedValue = "";

          break;
        }
        default: {
          this.currentStep++;
          break;
        }
      }

    },

    async setFormsData() {
      switch (this.currentStep) {
        case 1:
          this.userData = {
            company_name: this.$refs.companyName.text,
            account_manager_id: this.$refs.accountManager.selectedrow,
            customer_team_lead_id: this.$refs.customerTeamLead.selectedrow,
            courses: this.selectedCourseType == 'elearning' ? this.$refs.courses.value.map((course) => course.courseid) : [this.$refs.courses.selectedrow],
            limit_registration_domains: JSON.stringify(this.$refs.domainLimit.value.map((v) => v.name)),
            max_allowed_registrations: this.$refs.allowedRegsMax.text,
            training_manager_aproval: false, // this.$refs.approveByTM.checked,
          };
          break;

        case 2:
          this.userData.title = this.$refs.customTitle.text;
          this.userData.description = this.$refs.customDescription.text;

          if (this.$refs.logo.filelist.length > 0) {
            await common.getBase64FromFile(this.$refs.logo.filelist[0]).then((data) => {
              this.userData.logo = data;
            });
          } else {
            this.userData.logo = null;
          }

          this.SelectedNonMandatory.forEach(field => {
            if (field == 7) {
              let companyinfo = this.$refs.customCompanyList[0].text;
              this.userData.custom_company_list = companyinfo ? companyinfo.split("\n") : [];
            }
          });

          this.userData.non_mandatory_fields = this.SelectedNonMandatory;
          this.userData.captcha = this.$refs.captcha.ischecked;
          break;

        default:
          break;
      }
    },

    addNonMandatoryField(value) {
      if (!this.SelectedNonMandatory.includes(value) && value != null) {
        this.SelectedNonMandatory.push(value);
      }
    },

    deleteNonMandatoryField(value) {
      if (this.SelectedNonMandatory.includes(value)) {
        this.SelectedNonMandatory = this.SelectedNonMandatory.filter((element) => element !== value);
      }
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.$refs.formUrl.selectedValue);
    },
    copyFormUrl() {
      navigator.clipboard.writeText(this.$refs.formUrl.selectedValue);
      this.$bvToast.toast(this.$t(Constants.link_copied_success_toast_message), {
        title: this.$t(Constants.information_heading),
        autoHideDelay: 2000,
        appendToast: false,
      });
    },
    changeCourseSelection(type) {
      if (type == 2) {
        this.selectedCourseType = 'ilt';
      } else {
        this.selectedCourseType = 'elearning';
      }
    }
  },
  components: {
    Selector,
    MyButton,
    MyInput,
    ToggleSimple,
    MyTextArea,
    TextInputGroup,
    SelectInputGroup,
    FileInput,
    MultiSelect,
    MyCheckbox,
    //MyRadio
  },
};
</script>
